export const DATEFORMAT_SHORT_ISO = 'YYYY-MM-DD';
export const DATEFORMAT_LOCAL_STATE = 'DD.MM.YYYY';
export const COMMON_DATEFORMATS_LOCAL_STATE = ['DD.MM.YYYY', 'D.M.YYYY', 'DD.MM.YY', 'D.M.YY'];
export const HAUPTFAELLIGKEIT_DISPLAY_FORMAT = 'DD.MM.';
